import { Injectable, inject } from '@angular/core';
import { NavigationExtras, Params } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromRouter from '@ngrx/router-store';
import { Observable } from 'rxjs';
import * as fromRouterSelectors from '@nha/state/router/router.selectors';
import { IRouterUrlState } from '@nha/state/router/irouter-url-state.interface';

@Injectable()
export class RouterFacade {
	private _store = inject<Store<fromRouter.RouterReducerState<IRouterUrlState>>>(Store);


	/** selectors */

	routerStateUrl$: Observable<IRouterUrlState> = this._store.select(fromRouterSelectors.getRouterStateUrl);
	routeUrl$: Observable<string> = this._store.select(fromRouterSelectors.getRouteUrl);
	routeParams$: Observable<Params> = this._store.select(fromRouterSelectors.getRouteParams);
	routeQueryParams$: Observable<Params> = this._store.select(fromRouterSelectors.getRouteQueryParams);
	routeData: Observable<any> = this._store.select(fromRouterSelectors.getRouteData);

	/** parameterized selectors */

	routeParam$: (param: string) => Observable<string> = (param: string): Observable<string> => {
		return this._store.select(fromRouterSelectors.getRouteParam(param));
	};
}
